module.exports = __webpack_public_path__ + "static/media/3_22.ff5b86bc.png";